// TODO: should be marked as server-only
// import 'server-only';
import { unstable_cache as persistentCache } from 'next/cache';
import { CONFIGS_TAG, CONFIGS_TTL_SECONDS, Locale } from '@headless-workspace/config';
import { Result } from '@headless-workspace/core-domain';
import { PromiseHelpers } from '@headless-workspace/utils';
import {
    AppLinksBannerRepositoryType,
    BookingConfigRepositoryType,
    CommonDI,
    CrossBorderRepositoryType,
    CrossSellsBundlesConfigRepositoryType,
    DeliveryToStoreRepositoryType,
    FreeShippingPriceRepositoryType,
    LocalitiesConfigRepositoryType,
    LoggerType,
    LoyaltyConfigsRepositoryType,
    MiniSizeConfigRepositoryType,
    ModerationTermsRepositoryType,
    NewsletterConfigRepositoryType,
    NotifyMeRepositoryType,
    OmnibusInformationsRepositoryType,
    PriceLegalMentionsRepositoryType,
    PromoStandardTextRepositoryType,
    RedDotRepositoryType,
    Target2SellConfigRepositoryType,
    VipBrandsRepositoryType,
} from '../../../DI';
import { EcomConfigKeys } from '../../../server';
import { EcomConfigsHelpers } from './EcomConfigsHelpers';

export const ECOM_CONFIGS_ERROR_LABEL = 'GET_ECOM_CONFIGS_ERROR';

// export const ECOM_CONFIGS_MISSING_REQUIRED_CONFIGS_ERROR_MESSAGE = 'Missing required configs';

const ECOM_CONFIGS_CACHE_KEY = 'ecom-configs-cache';

export const getCachedEcomConfigs = persistentCache(
    async (locale: Locale): Promise<Partial<Record<EcomConfigKeys, Result<unknown>>>> => {
        try {
            const ecomConfigs: Record<EcomConfigKeys, Promise<Result<unknown>>> = {
                [EcomConfigKeys.EnableNewsletterBoostOptInOffer]:
                    CommonDI.get(NewsletterConfigRepositoryType).fetchEnableNewsletterBoostOptinOfferConfiguration(
                        locale,
                    ),
                [EcomConfigKeys.MiniSizeConfig]: CommonDI.get(MiniSizeConfigRepositoryType).getMiniSizeConfig(locale),
                [EcomConfigKeys.SmartBannerKey]: CommonDI.get(AppLinksBannerRepositoryType).fetchConfiguration(locale),
                [EcomConfigKeys.BooxiApiKey]:
                    CommonDI.get(BookingConfigRepositoryType).fetchBookingConfiguration(locale),
                [EcomConfigKeys.WoosmapApiKey]:
                    CommonDI.get(LocalitiesConfigRepositoryType).fetchLocalitiesConfiguration(locale),
                [EcomConfigKeys.LoyaltyConfig]:
                    CommonDI.get(LoyaltyConfigsRepositoryType).fetchLoyaltyConfiguration(locale),
                [EcomConfigKeys.ProductPriceShippingThreshold]: CommonDI.get(
                    FreeShippingPriceRepositoryType,
                ).fetchFreeShippingPrice(locale),
                [EcomConfigKeys.EnablePriceLegalMentions]: CommonDI.get(
                    PriceLegalMentionsRepositoryType,
                ).fetchEnablePriceLegalMentions(locale),
                [EcomConfigKeys.VipBrands]: CommonDI.get(VipBrandsRepositoryType).fetchVipBrands(locale),
                [EcomConfigKeys.EnableCrossBorder]: CommonDI.get(CrossBorderRepositoryType).getIsCrossBorder(locale),
                [EcomConfigKeys.EnableCrossSellsBundles]: CommonDI.get(CrossSellsBundlesConfigRepositoryType).isEnabled(
                    locale,
                ),
                [EcomConfigKeys.EnableDeliveryToStore]:
                    CommonDI.get(DeliveryToStoreRepositoryType).getIsDeliveryToStoreEnabled(locale),
                [EcomConfigKeys.ModerationList]: CommonDI.get(ModerationTermsRepositoryType).getModerationTerms(locale),
                [EcomConfigKeys.EnableNotifyMe]: CommonDI.get(NotifyMeRepositoryType).getIsNotifyMeEnabled(locale),
                [EcomConfigKeys.NotifyMeDisabledCountries]:
                    CommonDI.get(NotifyMeRepositoryType).getIsNotifyMeDisabledForCountry(locale),
                [EcomConfigKeys.RedDotConfig]: CommonDI.get(RedDotRepositoryType).fetchRedDotConfig(locale),
                [EcomConfigKeys.T2SConfig]: CommonDI.get(Target2SellConfigRepositoryType).fetchTarget2SellConfig(
                    locale,
                ),
                [EcomConfigKeys.OmnibusInformation]: CommonDI.get(
                    OmnibusInformationsRepositoryType,
                ).getOmnibusInformations(locale),
                [EcomConfigKeys.PromoStandardText]: CommonDI.get(PromoStandardTextRepositoryType).getPromoStandardText(
                    locale,
                ),
            };

            return await PromiseHelpers.resolveRecord(ecomConfigs);

            // Disable the configs check for now
            // const isMissingRequiredConfigs = EcomConfigsHelpers.hasMissingRequiredConfigs(allConfigs);
            //
            // if (isMissingRequiredConfigs) {
            //     CommonDI.get(LoggerType).warn(
            //         ECOM_CONFIGS_ERROR_LABEL,
            //         ECOM_CONFIGS_MISSING_REQUIRED_CONFIGS_ERROR_MESSAGE,
            //         Object.values(allConfigs).filter((config) => config.type === 'failure'),
            //     );
            // }
            //
            // // If one required config is a failure, we want to return a Record of ResultEmpty config
            // return isMissingRequiredConfigs ? EcomConfigsHelpers.createEcomEmptyConfigs() : allConfigs;
        } catch (error) {
            CommonDI.get(LoggerType).error(ECOM_CONFIGS_ERROR_LABEL, error);
            // In case of error, we return a Record of ResultEmpty config
            return EcomConfigsHelpers.createEcomEmptyConfigs();
        }
    },
    [ECOM_CONFIGS_CACHE_KEY],
    { tags: [CONFIGS_TAG], revalidate: CONFIGS_TTL_SECONDS },
);
